import * as React from "react";

function SvgFeather(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 17 24"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M1.52 23.72c.38-1.21.94-2.9 1.69-5.35 3.29-.52 4.65.42 6.79-3.37-1.7.52-3.74-1-3.63-1.62s4.75.47 7.79-3.88c-3.83.85-5.06-1-4.56-1.31 1.14-.65 4.52-.27 6.33-2a4.59 4.59 0 001-3.92c-.45-1-3.22-2.39-4.75-2.25s-3.99 5.85-4.7 5.81-.86-2.57.38-4.91a11 11 0 00-4.45 4c-1.4 2.88.13 9.51-.36 9.74S.9 11.57.41 10.09a8.32 8.32 0 001.28 7.58 21.15 21.15 0 00-1.21 5.44c-.03.89.88 1.13 1.04.61z" />
    </svg>
  );
}

const MemoSvgFeather = React.memo(SvgFeather);
export default MemoSvgFeather;
